import request from '@/plugin/axios'

export function latestOne(query) {
return request({
url: '/api/ocr/downloadList/latestOne',
method: 'get',
params: query
})
}

export function page(query) {
    return request({
    url: 'api/ocr/downloadList/page',
    method: 'get',
    params: query
    })
    }

export function addObj(obj) {
return request({
url: '/api/ocr/downloadList',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/ocr/downloadList/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/ocr/downloadList/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/ocr/downloadList/' + id,
method: 'put',
data: obj
})
}
